import { render } from "./pricing.vue?vue&type=template&id=789ef380&scoped=true"
import script from "./pricing.vue?vue&type=script&lang=js"
export * from "./pricing.vue?vue&type=script&lang=js"

import "./pricing.vue?vue&type=style&index=0&id=789ef380&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-789ef380"]])

export default __exports__